import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, InputLabel, Grid } from '@mui/material';
import { ConfigurationFieldLabel } from '../ConfigurationFieldLabel';
import { CurrentConfigureValue } from '../CurrentConfigureValue';
import { getProcessedStatus } from '../../ChargerConfigurationHelper';
import Toggle from '../../../../../../common/components/Toggle/Toggle';

const labelStyle = {
  marginLeft: 0,
};

export class ChargerConfigurationBooleanField extends React.Component {
  onChange = (event) => {
    this.props.input.onChange(event.target.checked);
    this.props.onFieldChange({ fieldName: this.props.input.name });
  };

  render() {
    const {
      label,
      description,
      currentValue,
      status,
      disabled,
      input: { value, name },
      meta: { dirty, form, touched },
      isBatchUpdate,
      isModal,
    } = this.props;

    const processedStatus = getProcessedStatus(isBatchUpdate ? dirty || touched : dirty, status);

    const wrappedLabel = <ConfigurationFieldLabel label={label} description={description} status={processedStatus} />;

    const currentValueComponent = isBatchUpdate ? (
      this.props.batchUpdateButton(touched)
    ) : (
      <CurrentConfigureValue dirty={dirty} status={processedStatus} currentValue={currentValue} />
    );

    return (
      <Grid container spacing={2}>
        <Grid item md={6} xs={12}>
          <div className="charger-configuration-checkbox-field">
            <FormControl fullWidth>
              <InputLabel shrink style={labelStyle}>
                {wrappedLabel}
              </InputLabel>
              <Toggle
                disabled={disabled}
                toggled={!!value}
                onToggle={this.onChange}
                value={value}
                inputProps={{ form, name }}
                color="primary"
              />
            </FormControl>
            {this.props.clearButton({ processed: processedStatus, actual: status })}
          </div>
        </Grid>
        {!isModal && (
          <Grid item className="current-value-grid-container">
            {currentValueComponent}
          </Grid>
        )}
      </Grid>
    );
  }
}

ChargerConfigurationBooleanField.propTypes = {
  label: PropTypes.string,
  meta: PropTypes.object,
  input: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  onBatchFieldChange: PropTypes.func,
  isBatchUpdate: PropTypes.bool,
};
